import math from 'mathjs'
const SystemCfg = {
  PicVersion:'20190327',      //图片的版本号
  IconVerion:'20190327',      //Icon的版本号
  CdnCaChe:window.location.href.indexOf("wx.yumstone")!=-1?true:false,             //是否cdn缓存
};
let isSortBy = false;     //是否排序过
let sortBy = function(attr,rev){
  //第二个参数没有传递 默认升序排列
  if(rev ===  undefined){
    rev = 1;
  }else{
    rev = (rev) ? 1 : -1;
  }
  return function(a,b){
    a = a[attr];
    b = b[attr];
    if(a < b){
      return rev * -1;
    }
    if(a > b){
      return rev * 1;
    }
    return 0;

  }
};
export default {
  config : {
    test:false,                                                           //是否开启测试  true 测试  false 非测试
    // domain:'http://dev.yumstone.com',                                   // 测试域名
    domain:'',                                                            //发布域名
    sellerId:'',                                                          //商户id
    storeId:'',                                                           //门店id
    storeName:'',                                                         //门店名称
    longitude:0,                                                          //当前经度
    latitude:0,                                                           //当前纬度
    menuClass:0 ,                                                         //菜单类型 0:堂食菜谱 1:外卖菜谱
    orderType:1,                                                          //点菜类型 0：堂食 1：自提 2：外卖
    isTakeTable:false,                                                    //是否带餐桌号
    sendRule:0,                                                           //外卖配送规则
    distributionCharge:0,                                                 //外卖配送费
    sendAmount:0,                                                         //外卖起送金额
    tableNo:'',                                                           //餐桌号
    openSmartSort:0 ,                                                     //是否允许智能排序   0 不允许   1 允许
  },
  //门店外卖设置
  takeoutConfig:{
      address: "",
      businessTime: [{startTime: "00:00", endTime: "23:00"}],
      contact: "",
      deliverySelf: 0,
      distributionCharge: 0,
      gdlat: "",
      gdlng: "",
      houseNo: "",
      isBusiness: 1,
      name: "",
      sellerid: "",
      sendAmount:0,
      sendDistance:0,
      sendRule: 0,
      sendTime: 0,
      split: 0,
      storeid: "",
      telephone: ""
  },
  //点外卖时用户信息
  userTakeoutInfo:{
    deliveryType:0,//0：自提 1:外送
    timeType:0,    //0: 即时 1：预约
    timeText:"",   //时间文本
    time:undefined,  //预约时间
    distance:0,    //配送距离
    address:"",    //配送地址
    tel:"",        //收货人电话
    username:"",   //收货人
    gdLat:"",      //高德纬度
    gdLng:""       //高德经度
  },
  orderedTotal  : {count:0,amount:0,qty:0,outtradeno:'',billMemo:''},                //点菜概况
  bidianMenu:[""],                                                       //必点菜单
  menufilterData:[],                                                     //可点菜数据
  saleout:[],                                                            //保存估清数据
  sideDish:[],                                                           //配菜数组
  menuData:[],                                                           //组装后的菜单数据
  menuTypeDataMap:{},                                                    //组装后的菜单类型数据对象,根据类型Code获取数据详情
  menuItemDataMap:{},                                                    //组装后的菜单明细数据对象,根据菜品Code获取数据详情
  picData:[],                                                            //保存原始图片数据
  suitBillData:[],                                                       //已点套餐菜品数
  noSuitBillData:[],                                                     //已点非套餐菜品数
  images:[],                                                             //Image对象数组
  picArray:[],                                                           //预加载图片数组
  recommendArray:[],                                                     //获取的推荐菜品数据
  stores:[],                                                             //所有门店数据
  getBgPicData:null,                                                     //背景图片数据
  RecommendAtionState:null,                                              //推荐菜状态数据
  //清空所有缓存数据
  clearAllCacheData (){
    this.saleout.length = 0;
    this.sideDish.length = 0;
    this.menuData.length = 0;
    this.picData.length = 0;
    this.suitBillData.length = 0;
    this.noSuitBillData.length = 0;
    this.images.length = 0;
    this.picArray.length = 0;
    this.recommendArray.length = 0;
    this.orderedTotal.count=0;
    this.orderedTotal.amount=0;
    this.orderedTotal.qty=0;
    this.orderedTotal.outtradeno='';
  },


  /**
   * 添加套餐数据
   * @param item
   */
  setSuitData(item){
    this.suitBillData.push(item);
    this.calculateCarTotal();
    this.calculateTypeNum();
  },
  /**
   * 添加非套餐数据
   */
  setNoSuitData(type,order){
    let isFind = this.findType(type);
    if(isFind){
      this.noSuitBillData.forEach((tp)=>{
        if(type.code == tp.code){
          tp.menuItem.push(order);
        }
      });
    }else {
      type.menuItem = [];
      type.menuItem.push(order);
      this.noSuitBillData.push(type);
    }
    this.calculateCarTotal();
    this.calculateTypeNum();
  },
  /**
   * 查找非套餐数据是否有该类型
   * @param type
   */
  findType(type){
    let find = false ;
    this.noSuitBillData.forEach((tp)=>{
      if(type.code == tp.code){
        find = true;
      }
    });
    return find;
  },

  /**
   * 计算购物车概况
   * [calculateCarTotal description]
   * @return {[type]} [description]
   */
  calculateCarTotal(){
    let _amount = 0;
    let _count = 0;
    let _qty = 0;
    //计算非套餐
    if(this.noSuitBillData.length>0){
      this.noSuitBillData.forEach(type=>{
        _count += type.menuItem.length||0;
        type.menuItem.forEach(item=>{
          _qty += item.num;
          _amount += item.num*item.price;
          item.menuItem.forEach(function(v){
            _amount += v.num*v.price;
          });
        });
      }) ;
    }

    //计算套餐
    if(this.suitBillData.length>0){
      _count+= this.suitBillData.length;
      this.suitBillData.filter((suiteItem)=>{
        _amount += suiteItem.price*suiteItem.num;
        _qty += suiteItem.num;
      })
    }
    this.orderedTotal.count = _count;
    this.orderedTotal.amount = Math.round(_amount * 100) / 100;
    this.orderedTotal.qty = _qty;
    this.setCacheData()
  },

  /**
   * [calculateTypeNum description]
   * 计算菜品类型下点菜的道数，原始数据与已点菜的数据对比，检查点过的菜，打钩
   * @return {[type]} [description]
   */
  calculateTypeNum(){
    this.menuData.forEach(type=>{
      type.num=0;
      type.menuItem.forEach(item=>item.check=0);
    });
    //非套餐
    if(this.noSuitBillData.length>0 && this.menuData.length>0){
      this.noSuitBillData.forEach((type,typeIndex)=>{
        type.menuItem.forEach((item,itemIndex)=>{
          if(item.num>0 && this.menuItemDataMap[item.code]){
            this.menuItemDataMap[item.code].check=1;
          }else{
            if(this.menuItemDataMap[item.code]){
              this.menuItemDataMap[item.code].check=0;
              type.menuItem.splice(itemIndex,1);
            }
          }
        });
        this.menuTypeDataMap[type.code].num = type.menuItem.length;
        if(type.menuItem.length==0){
          this.noSuitBillData.splice(typeIndex,1);
        }
      });
    }
    //  套餐
    if(this.suitBillData.length>0){
      this.menuData.forEach(type=>{
        if(type.isGroup == 1){
          this.menuTypeDataMap[type.code].num = this.suitBillData.length;
          this.suitBillData.forEach((item)=>{
            if(item.num>0){
              this.menuItemDataMap[item.code].check=1;
            }
          })
        }
      });
    }
  },

  /**
   * 给本地保存已点菜单数据
   */
  setCacheData (){
    let _suitdatakey = "999"+this.config.sellerId+this.config.storeId+this.config.menuClass;//套餐key
    let _nosuitdatakey = "000" +this.config.sellerId+this.config.storeId+this.config.menuClass;//非套餐key
    let _billHead =   "bh_" +this.config.sellerId+this.config.storeId+this.config.menuClass;//账单头key
    let _cacheTime = "te_"+this.config.sellerId + this.config.storeId+this.config.menuClass;
    this.setcache(_suitdatakey,JSON.stringify(this.suitBillData));
    this.setcache(_nosuitdatakey, JSON.stringify(this.noSuitBillData));
    this.setcache(_billHead,JSON.stringify(this.orderedTotal));
    this.setcache(_cacheTime,(new Date()).valueOf());
  },

  setBillHeadCache(){
      let _billHead =   "bh_" +this.config.sellerId+this.config.storeId+this.config.menuClass;//账单头key
      this.setcache(_billHead,JSON.stringify(this.orderedTotal));
  },

  getBillHeadCache(){
      let _billHeadKey =   "bh_" +this.config.sellerId+this.config.storeId+this.config.menuClass;//账单头key
      Object.assign(this.orderedTotal,JSON.parse(this.getcache(_billHeadKey)));
  } ,

  getCacheData(){
      let _suit = "999" + this.config.sellerId + this.config.storeId + this.config.menuClass;
      let _nosuit = "000" + this.config.sellerId + this.config.storeId + this.config.menuClass;
      let _billHead = "bh_" + this.config.sellerId + this.config.storeId + this.config.menuClass;//账单头key
      let _cacheTime = "te_"+this.config.sellerId + this.config.storeId+this.config.menuClass;
      let delatTime = (new Date().valueOf() - this.getcache(_cacheTime)) / (60 * 1000);
      if (delatTime > 30) {
          this.removecache(_suit);
          this.removecache(_nosuit);
          this.removecache(_billHead);
          this.removecache(_cacheTime);
      } else {
          this.suitBillData.length = 0;
          this.noSuitBillData.length = 0;
          this.suitBillData.append(JSON.parse(this.getcache(_suit)) || []);
          this.noSuitBillData.append(JSON.parse(this.getcache(_nosuit)) || []);
          Object.assign(this.orderedTotal,JSON.parse(this.getcache(_billHead)));
          this.calculateCarTotal();
          this.calculateTypeNum();
      }
  },

  delAllCacheData(){
      let _suitdatakey = "999"+this.config.sellerId+this.config.storeId+this.config.menuClass;//套餐key
      let _nosuitdatakey = "000" +this.config.sellerId+this.config.storeId+this.config.menuClass;//非套餐key
      this.removecache(_suitdatakey);
      this.removecache(_nosuitdatakey);
  },

  //保存数据
  setcache(key,value){
    localStorage.setItem(key,value);
  },
  //取数据
  getcache(key){
    return localStorage.getItem(key);
  },
  //删除本地数据
  removecache(key){
    localStorage.removeItem(key);
  },


  /**
   * 修改微信title
   * @param title
   */
  changeTitle(title) {
    document.title = title;
  },
  /**
   * 返回配置信息
   * @returns {{IconVerion: string, CdnCaChe: boolean, PicVersion: string}}
   */
  getSystemCfg(){
    return SystemCfg;
  },

  /**
   * 根据不同场景获取域名
   * @returns {string}
   */
  getCdnDomain:function(){
    if(SystemCfg.CdnCaChe){
      return '//wxcdn.yumstone.com' ;
    }else {
      return this.config.domain ;
    }
  },

  /**
   * 保存是否自动排序的标识
   * @param num
   */
  setOpenSmartSort(num) {
    this.config.openSmartSort = num ;
  },

  /**
   * 获取是否自动排序的标识
   * @returns {number}
   */
  getOpenSmartSort(){
    return this.config.openSmartSort ;
  },
  /**
   * 是否自动排序
   */
  sortPicMode(num){
    if(isSortBy)return;
    if(num>0){
      isSortBy =true;
      this.menuData.forEach((picItem)=> {
        picItem.menuItem =  picItem.menuItem.sort(sortBy('sortNum',false));
      })
    }
  },
  /**
   * 返回注册会员URL
   */
  getVipRegisterUrl(){
    return "{0}/weixin/{1}/vip/register/{2}.html".format(this.config.domain,this.config.sellerId,new Date().valueOf());
  },

  //过滤可点菜数据
  //如果某个菜存在于套餐内，则展示那个套餐
  doMenufilterData(data){
    let menufilterData = this.menufilterData;
    if(menufilterData.length == 0){
      return data;
    }
    let resData= [];
    for(let item of data){
      let obj = item;
      obj.newmenuitem = [];
      let menuitem = item.menuitem?item.menuitem:item.menuItem;
      for(let item2 of menuitem){
        if(menufilterData.indexOf(item2.code) != -1){
          obj.newmenuitem.push(item2)
        }
      }
      if(item.menuitem){
        obj.menuitem = obj.newmenuitem;
      }else{
        obj.menuItem = obj.newmenuitem;
      }
      delete obj.newmenuitem;
      if(obj.menuitem && obj.menuitem.length>0){
        resData.push(obj);
      }
      if(obj.menuItem && obj.menuItem.length>0){
        resData.push(obj);
      }
    }
    return resData
  },

  //过滤套餐数据,如果套餐的具体数据中只要有一个菜没有，那就将此套餐移除
  doMenufilterSuiteData(suiteData){
    let menufilterData = this.menufilterData; //过滤后可展示的数据
    if(menufilterData.length == 0){
      return suiteData;
    }
    let arr = [];
    for(let item of suiteData){
      let i=0;
      for(let item2 of item.menuitem){
        if(menufilterData.indexOf(item2.code)!=-1){
          i++
        }
      }
      // 过滤后可显示的数据中 应该包含所有套餐中的数据，只要有一个菜没有，那么这个套餐将被移除
      if(i == item.menuitem.length){
        arr.push(item)
      }
    }
    return arr;
  },

  //通过图片数据，和原始数据产生新的菜单数据
  createMenuData(menuData, suiteData) {
    menuData = this.doMenufilterData(menuData);
    suiteData = this.doMenufilterSuiteData(suiteData);
    // this.picData = this.doMenufilterData(this.picData);

    let _originMenuType = {};
    let _originMenuItem = {};
    let _originBidianMenuItem = {};
    let _newBidianMenu = [];
    menuData.forEach(type=>{
      _originMenuType[type.code] = type;
      type.menuitem.forEach(item=>{
        let standard = {standard: item.standard, price: item.price,memberprice:item.memberprice};
        if(_originMenuItem[item.code]){
          _originMenuItem[item.code].standards.push(standard);
        }else{
          standard.isSelect = true;
          _originMenuItem[item.code] = item;
          _originMenuItem[item.code].standards = [standard];
          _originMenuItem[item.code].remark = [];
          _originMenuItem[item.code].price = math.round(item.price*1.00,2);
          _originMenuItem[item.code].memperprice = math.round((item.memperprice||item.price)*1.00,2);
        }
        if(item.memo && _originMenuItem[item.code].remark.length==0){
          let remarks = item.memo.split('|');
          remarks.forEach(remarkItem=>{
            let _d = remarkItem.split('@');
            let _o = {name:_d[0]||'',price:_d[1]||0,mark:_d[2]||0,code:_d[3]||''};
            _originMenuItem[item.code].remark.push(_o);
          });
        }
      });
    });
    suiteData.forEach(type=>{
      _originMenuType['s_'+type.code] = type;
      _originMenuType['s_'+type.code].group = [];
      let _suiteprice = 0,_suiteMemberPrice = 0;
      type.menuitem.forEach(item=>{
        if(_originMenuType['s_'+type.code+'_'+item.groupNo]){
          _originMenuType['s_'+type.code+'_'+item.groupNo].push(item);
        }else{
          let _group = {count: 0,groupName:item.groupName,groupNo: item.groupNo,suiteItem: [item]};
          _originMenuType['s_'+type.code].group.push(_group);
          _originMenuType['s_'+type.code+'_'+item.groupNo] = _group.suiteItem;
        }
        if(item.selectflag==1){
          _suiteprice += item.price*item.num;
          _suiteMemberPrice += (item.memberprice||item.price)*item.num;
        }
        item.remark = [];
        if(_originMenuItem[item.code] && Array.isArray(_originMenuItem[item.code].remark)){
          _originMenuItem[item.code].remark.forEach(remarkItem=>{if(remarkItem.price==0){item.remark.push(remarkItem);}});
        }
      });
      _originMenuType['s_'+type.code].price = math.round(_suiteprice*1.00,2);
      _originMenuType['s_'+type.code].memberprice = math.round(_suiteMemberPrice*1.00,2);
    });
    this.bidianMenu.forEach(item=>{_originBidianMenuItem[item]=true});

    //必点菜谱处理
    //新的处理方式
    this.menuData.length = 0;
    this.picData.forEach(type=>{
      if(type.menuItem.length>0){//分类下有菜单则显示
        if(type.isGroup==0 && _originMenuType[type.code]){//堂食
          type.name = _originMenuType[type.code].name;
          type.sndname = _originMenuType[type.code].sndname;
          for(let i =0;i<type.menuItem.length;i++){
            let item = type.menuItem[i];
            if(!_originMenuItem[item.code] || !_originMenuItem[item.code].name){
              type.menuItem.splice(i,1);
              i--;
            }
            if(_originMenuItem[item.code] && _originMenuItem[item.code].name){
              item.minOrderNum = item.minOrderNum ||1;
              item.drink = _originMenuItem[item.code].drink || 0;
              item.name = _originMenuItem[item.code].name;
              item.sndname = _originMenuItem[item.code].sndname;
              item.price = _originMenuItem[item.code].price*1;
              item.memberprice = _originMenuItem[item.code].memberprice*1;
              item.memoflag= _originMenuItem[item.code].memoflag;
              item.remark = _originMenuItem[item.code].remark;
              item.standard = _originMenuItem[item.code].standard;
              item.standards = _originMenuItem[item.code].standards;
              item.memberNo = _originMenuItem[item.code].memberNo;

              if(!item.hasOwnProperty('indexpicshow')){
                item.indexpicshow = 1;
              }
              if(item.picPath.lastIndexOf('.jpg')>0){
                this.picArray.push(item.picPath);
              }
              if(item.picMode == 0){    //无图
                item.sortNum = 0;
              }
              if(item.picMode == 1 && item.indexpicshow==1){
                item.sortNum = 100;
              } else if(item.picMode == 1 && item.indexpicshow==0){
                item.sortNum = 0;
              }
              if(item.picMode == 2 && item.indexpicshow==1){
                item.sortNum = 20;
              } else if(item.picMode == 2 && item.indexpicshow==0){
                item.sortNum = 0;
              }
              item.picPath =this.getCdnDomain()+"/weixin/document/"+item.picPath+"?v="+SystemCfg.PicVersion;
              item.iconPath.forEach((iconItem,index)=>{
                item.iconPath[index] = this.getCdnDomain() + "/weixin/"+iconItem+"?v="+SystemCfg.IconVerion;
              });


              this.menuItemDataMap[item.code]= item;
              this.menuItemDataMap[item.code].type = type;
              //处理必点菜,且已上架
              if(_originBidianMenuItem[item.code]){
                  //多规格只显示一次
                  _originBidianMenuItem[item.code] = false;
                  _newBidianMenu.push(item);
              }
            }
          };
        }else if(type.isGroup==1 && suiteData.length>0){
          type.name = '套餐';
          type.sndname = 'Suite';
          type.code = '999999';
          for(let i=0;i<type.menuItem.length;i++){
            let suite = type.menuItem[i];
            if(!_originMenuType['s_'+suite.code] || !_originMenuType['s_'+suite.code].name){
              type.menuItem.splice(i,1);
              i--;
            }
            if(_originMenuType['s_'+suite.code]){
              suite.minOrderNum = suite.minOrderNum ||1;
              suite.name = _originMenuType['s_'+suite.code].name;
              suite.sndname = _originMenuType['s_'+suite.code].sndname;
              suite.memberNo = _originMenuType['s_'+suite.code].memberNo;
              suite.price = _originMenuType['s_'+suite.code].price*1;
              suite.memberprice = _originMenuType['s_'+suite.code].memberprice*1;
              suite.group = _originMenuType['s_'+suite.code].group;
              if(!suite.hasOwnProperty('indexpicshow')){
                suite.indexpicshow = 1;
              }
              this.menuItemDataMap[suite.code]=suite;
              if(suite.picPath.lastIndexOf('.jpg')>0){
                this.picArray.push(suite.picPath);
              }
              if(suite.picMode == 0){
                suite.sortNum = 0;
              }
              if(suite.picMode == 1 && suite.indexpicshow==1){
                suite.sortNum = 100;
              }else if(suite.picMode == 1 && suite.indexpicshow==0) {
                suite.sortNum = 0;
              }
              if(suite.picMode == 2 && suite.indexpicshow==1){
                suite.sortNum = 20;
              }else if(suite.picMode == 2 && suite.indexpicshow==0){
                suite.sortNum = 0;
              }
              suite.picPath =this.getCdnDomain()+"/weixin/document/"+suite.picPath+"?v="+SystemCfg.PicVersion;
              suite.iconPath.forEach((iconItem,index)=>{
                suite.iconPath[index] = this.getCdnDomain() + "/weixin/"+iconItem+"?v="+SystemCfg.IconVerion;
              });
            }
          }
        }
        if(type.name){
          this.menuTypeDataMap[type.code]=type;
          this.menuData.push(type);
        }
      }
    });

    //一系列过滤之后，如果套餐里一个菜都没有，那直接去掉套餐
    for(let i=0;i<this.menuData.length;i++){
      let item = this.menuData[i];
      if(item.code == '999999' && item.menuItem.length == 0){
        this.menuData.splice(i,1)
        delete this.menuTypeDataMap[item.code];
        i--;
      }
    }
    menuData = null;
    suiteData = null;

    if(_newBidianMenu.length>0){
      let _bidianType = {
        code:'bidian',
        name:'必点项',
        isGroup:0,
        menuItem:_newBidianMenu
      };
      this.menuTypeDataMap[_bidianType.code]=_bidianType;
      this.menuData.splice(0, 0, _bidianType);
    }
    this.bidianMenu = _newBidianMenu;
    _originMenuType = null;
    _originMenuItem = null;
    _originBidianMenuItem = null;
    this.preloadImages();
  },

  /**
   * 套餐菜品沽清
   * @param suite
   */
  dealGroupSaleout(suiteItem){
    this.saleout.forEach((item)=>{
      if(item === suiteItem.code){
        suiteItem.isSaleout = true;
      }
    })
  },

  //处理沽清数据
  dealSaleOut(){
    //非套餐沽清数据
    this.saleout.forEach((item)=>{
      if(this.menuItemDataMap[item]){
        this.menuItemDataMap[item].isSaleout = true;
      }
    });
    if(!this.menuTypeDataMap[999999])return;
    //  套餐详情沽清
    if(!this.menuTypeDataMap[999999])return;
    this.menuTypeDataMap[999999].menuItem.forEach((suite)=>{
      if(suite.group){
        suite.group.forEach(group=>{
          group.suiteItem.forEach((item)=>{
            this.dealGroupSaleout(item);
          })
        })
      }
    });


  },

  /**
   * 预加载图片
   * [preloadImages description]
   * @param  {[type]} picArray [description]
   * @return {[type]}          [description]
   */
  preloadImages() {
    return new Promise((resoleve, reject) => {
      if (this.images.length>0) {
        resoleve();
        return;
      }
      console.log('this.picArray',this.picArray);

      for(let i=0;i<5;++i){//只预加载前5张菜单图片
        let picItemPath = this.picArray[i];
        if(!picItemPath) break;
        let imgObj = new Image();
        imgObj.src = this.getCdnDomain() + '/weixin/document/' + picItemPath;
        imgObj.onload = () => {
          this.images.push(imgObj);
        };
        imgObj.onerror = () => {
          console.log("imgObj.onerror");
          this.images.push(imgObj);
          reject()
        }
      }
      resoleve();
    });
  },

}



// WEBPACK FOOTER //
// ./src/service/ServiceUtils.js